module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Regular.5f5d34f2.woff";